
import { Component } from "@angular/core";

@Component({
    selector: "app-main-template-logo",
    imports: [],
    templateUrl: "./logo.component.html"
})
export class LogoComponent {}
